import { render, staticRenderFns } from "./LinkToMobile.vue?vue&type=template&id=277ae7ce&"
import script from "./LinkToMobile.vue?vue&type=script&lang=js&"
export * from "./LinkToMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports